(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ambient-video"] && !Shopify.designMode) return;
  try {
    /* Pause and resume on click, Space or Enter; the label follows the state.
     No reduced-motion branch here, on purpose: see the doc above. */
  class AmbientVideo extends HTMLElement {
    connectedCallback() {
      /* The mobile file first, before anything is read from the DOM: it takes
         the place of the desktop one, which is why the desktop tag ships with
         `preload="none"` whenever a mobile one exists. A `<template>` holds
         inert content, so nothing was fetched for the file that loses. */
      const mobile = this.querySelector('[data-video-mobile]');
      if (mobile && window.matchMedia('(max-width: 900px)').matches) {
        const current = this.querySelector('video');
        /* `importNode`, not `content.cloneNode`: the clone is then created in
           this document rather than in the template's inert one, which is
           where WebKit decides a media element's autoplay restrictions. */
        if (current) current.replaceWith(document.importNode(mobile.content, true));
      }

      this.video = this.querySelector('video');
      if (!this.video) return;
      /* `video_tag` puts a fallback <img> inside the <video> with no alt and
         offers no way of setting one: decorative. */
      this.video.querySelectorAll('img:not([alt])').forEach((img) => img.setAttribute('alt', ''));
      this.video.tabIndex = 0;
      this.video.addEventListener('click', this.toggle);
      this.video.addEventListener('keydown', this.onKeyDown);
      this.video.addEventListener('play', this.label);
      this.video.addEventListener('pause', this.label);
      this.label();
    }

    toggle = () => {
      if (this.video.paused) this.video.play();
      else this.video.pause();
    };

    onKeyDown = (event) => {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      event.preventDefault();
      this.toggle();
    };

    label = () => {
      this.video.setAttribute('aria-label', this.video.paused ? this.dataset.labelPlay : this.dataset.labelPause);
    };
  }

  if (!customElements.get('ambient-video')) {
    customElements.define('ambient-video', AmbientVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["core-intro"] && !Shopify.designMode) return;
  try {
    class CoreIntro extends HTMLElement {
    connectedCallback() {
      this.measure = this.measure.bind(this);
      this.measure();
      window.addEventListener('resize', this.measure);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.measure);
    }

    measure() {
      const root = document.documentElement;
      const styles = getComputedStyle(root);

      this.style.setProperty('--core-intro-height', this.offsetHeight + 'px');
      root.style.setProperty('--viewport-width', root.clientWidth + 'px');

      const frame = document.querySelector('.header-group');
      if (!frame) return;

      let height = frame.getBoundingClientRect().height;

      /* The frame shrinks while scrolling down. The offset must not follow it,
         or every pinned element of the page would drift during the collapse:
         give back what the collapsed bar has lost. */
      if (frame.classList.contains('is-collapsed')) {
        const large = parseFloat(styles.getPropertyValue('--header-height'));
        const small = parseFloat(styles.getPropertyValue('--header-height-collapsed'));
        height += large - small;
      }

      const gutter = parseFloat(styles.getPropertyValue('--gutter'));
      root.style.setProperty('--sticky-offset-top', gutter + height + 'px');
    }
  }

  customElements.define('core-intro', CoreIntro);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    /* Ticks once a second from `data-end` (seconds). Rewrites the digits of a
     unit only when its value changes, which keeps three of the four untouched
     most of the time. */
  class CountDown extends HTMLElement {
    connectedCallback() {
      this.end = Number(this.dataset.end) * 1000;
      if (!this.end) return;

      this.values = {};
      this.targets = {};
      this.querySelectorAll('[data-countdown-value]').forEach((element) => {
        this.targets[element.dataset.countdownValue] = element;
      });

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));

      this.render('d', Math.floor(left / 86400));
      this.render('h', Math.floor((left % 86400) / 3600));
      this.render('m', Math.floor((left % 3600) / 60));
      this.render('s', left % 60);

      if (left === 0) clearInterval(this.timer);
    }

    render(key, value) {
      const target = this.targets[key];
      if (!target || this.values[key] === value) return;
      this.values[key] = value;

      target.replaceChildren(
        ...String(value)
          .padStart(2, '0')
          .split('')
          .map((digit) => {
            const span = document.createElement('span');
            span.className = 'countdown__digit';
            span.textContent = digit;
            return span;
          })
      );
    }
  }

  if (!customElements.get('count-down')) customElements.define('count-down', CountDown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["legal-accordion"] && !Shopify.designMode) return;
  try {
    class LegalAccordion extends HTMLElement {
    connectedCallback() {
      window.addEventListener('hashchange', this.openFromHash);
      this.openFromHash();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.openFromHash);
    }

    openFromHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;

      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return;

      const item = target.closest('details');
      if (!item) return;

      item.open = true;
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    };
  }

  if (!customElements.get('legal-accordion')) {
    customElements.define('legal-accordion', LegalAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quicklinks"] && !Shopify.designMode) return;
  try {
    /* Desktop comfort for the overflowing bar (the original site only offers
     the native touch swipe): the vertical wheel scrolls it horizontally, and
     it can be dragged with the mouse. No inertia, no smooth scrolling. */
  class QuickLinksScroller extends HTMLElement {
    connectedCallback() {
      this.revealCurrent();
      this.addEventListener('wheel', this.onWheel, { passive: false });
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointermove', this.onPointerMove);
      this.addEventListener('pointerup', this.onPointerEnd);
      this.addEventListener('pointercancel', this.onPointerEnd);
      this.addEventListener('click', this.onClick, true);
      window.addEventListener('pagehide', this.save);
    }

    disconnectedCallback() {
      window.removeEventListener('pagehide', this.save);
    }

    /* Remembered for the next page: the inline script under the bar restores
       this position before paint when the group is the same. */
    save = () => {
      try {
        sessionStorage.setItem('quick-links', JSON.stringify({ key: this.dataset.key, url: location.href, scrollLeft: this.scrollLeft }));
      } catch (error) {}
    };

    get overflows() {
      return this.scrollWidth > this.clientWidth + 1;
    }

    /* On arrival, the bar glides from its start to the current link, which
       ends at the left edge of the visible area (clamped at the end of the
       bar). Mirrors the ~500ms ease-out slide of the original after a click;
       instant when the visitor prefers reduced motion. */
    revealCurrent() {
      const current = this.querySelector('.quick-links__item--current');
      if (!current || !this.overflows) return;

      const target = Math.min(
        this.scrollWidth - this.clientWidth,
        current.getBoundingClientRect().left - this.getBoundingClientRect().left + this.scrollLeft
      );
      if (target === this.scrollLeft) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.scrollLeft = target;
        return;
      }

      const from = this.scrollLeft;
      const duration = 500;
      let start = null;
      const step = (now) => {
        if (start === null) start = now;
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.scrollLeft = from + (target - from) * eased;
        if (progress < 1) this.frame = requestAnimationFrame(step);
      };
      this.frame = requestAnimationFrame(step);
    }

    /* Any wheel or mouse interaction takes over from the slide. */
    stopReveal() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    onWheel = (event) => {
      if (!this.overflows || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

      const max = this.scrollWidth - this.clientWidth;
      const next = Math.min(max, Math.max(0, this.scrollLeft + event.deltaY));
      if (next === this.scrollLeft) return;

      event.preventDefault();
      this.stopReveal();
      this.scrollLeft = next;
    };

    onPointerDown = (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !this.overflows) return;
      this.stopReveal();
      this.startX = event.clientX;
      this.startScroll = this.scrollLeft;
      this.pointerId = event.pointerId;
      this.dragged = false;
    };

    onPointerMove = (event) => {
      if (event.pointerId !== this.pointerId) return;

      const delta = event.clientX - this.startX;
      if (!this.dragged) {
        if (Math.abs(delta) < 5) return;
        this.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(event.pointerId);
      }
      this.scrollLeft = this.startScroll - delta;
    };

    onPointerEnd = (event) => {
      if (event.pointerId !== this.pointerId) return;
      this.pointerId = null;
      if (this.dragged) {
        this.releasePointerCapture(event.pointerId);
        this.classList.remove('is-dragging');
        /* The click that follows a drag must not open the link. */
        setTimeout(() => { this.dragged = false; }, 0);
      }
    };

    onClick = (event) => {
      if (!this.dragged) return;
      event.preventDefault();
      event.stopPropagation();
    };
  }

  if (!customElements.get('quick-links-scroller')) {
    customElements.define('quick-links-scroller', QuickLinksScroller);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sustainability-stack"] && !Shopify.designMode) return;
  try {
    class SustainabilityStack extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => this.measure());

      for (const part of this.querySelectorAll('[data-stack]')) {
        this.observer.observe(part);
      }

      this.measure();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    measure() {
      for (const name of ['top', 'bottom']) {
        const part = this.querySelector('[data-stack="' + name + '"]');
        if (!part) continue;

        /* The part already reserves the room of the other one through its own
           padding or margin; take it back out, or both would grow at each
           measurement. */
        const styles = getComputedStyle(part);
        const reserved = name === 'top'
          ? parseFloat(styles.paddingBottom)
          : parseFloat(styles.paddingTop) + parseFloat(styles.marginBottom);

        const height = part.getBoundingClientRect().height - reserved;
        this.style.setProperty('--' + name + '-height', Math.max(height, 0) + 'px');
      }
    }
  }

  if (!customElements.get('sustainability-stack')) {
    customElements.define('sustainability-stack', SustainabilityStack);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-player"] && !Shopify.designMode) return;
  try {
    class VideoPlayer extends HTMLElement {
    connectedCallback() {
      /* The mobile file first, before anything is read from the DOM: it takes
         the place of the desktop one, which is why the desktop tag ships with
         `preload="none"` whenever a mobile one exists. A `<template>` holds
         inert content, so nothing was fetched for the file that loses. */
      const mobile = this.querySelector('[data-video-mobile]');
      if (mobile && window.matchMedia('(max-width: 900px)').matches) {
        const current = this.querySelector('video');
        /* `importNode`, not `content.cloneNode`: the clone is then created in
           this document rather than in the template's inert one, which is
           where WebKit decides a media element's autoplay restrictions. */
        if (current) current.replaceWith(document.importNode(mobile.content, true));
      }

      /* Same reason as the element selector in the stylesheet: a tag built by
         `video_tag` is found whether or not the class made it through. */
      this.video = this.querySelector('.video-player__video') || this.querySelector('video');
      this.playButton = this.querySelector('.video-player__play');
      this.playLabel = this.querySelector('.video-player__play-label');
      this.iconPlay = this.querySelector('.video-player__icon-play');
      this.iconPause = this.querySelector('.video-player__icon-pause');
      this.time = this.querySelector('.video-player__time');
      this.duration = this.querySelector('.video-player__duration');
      this.timeline = this.querySelector('.video-player__timeline-wrapper');
      this.progress = this.querySelector('.video-player__progress');
      this.muteButton = this.querySelector('.video-player__mute');
      this.fullscreenButton = this.querySelector('.video-player__fullscreen');

      if (!this.video) return;

      /* `video_tag` puts a fallback <img> inside the <video> with no alt, and
         offers no way of setting one: mark it decorative, the bar names the
         film. */
      this.video.querySelectorAll('img:not([alt])').forEach((img) => img.setAttribute('alt', ''));

      this.video.addEventListener('error', () => this.fail());
      this.video.addEventListener('loadedmetadata', () => this.onMetadata());
      this.video.addEventListener('timeupdate', () => this.onTimeUpdate());
      this.video.addEventListener('play', () => this.onPlayState());
      this.video.addEventListener('pause', () => this.onPlayState());

      this.playButton.addEventListener('click', () => this.togglePlay());
      this.muteButton.addEventListener('click', () => this.toggleMute());
      this.fullscreenButton.addEventListener('click', () => this.toggleFullscreen());
      this.timeline.addEventListener('click', (event) => this.seek(event));
      this.timeline.addEventListener('keydown', (event) => this.onTimelineKey(event));
      document.addEventListener('fullscreenchange', this.syncFullscreenLabel);

      if (this.video.error) this.fail();
      if (this.video.readyState > 0) this.onMetadata();
      this.onPlayState();
      this.syncMuteLabel();
    }

    fail() {
      this.hidden = true;
      this.dispatchEvent(new CustomEvent('video-player:error', { bubbles: true }));
    }

    format(seconds) {
      if (!isFinite(seconds)) return '00:00:00';
      const minutes = Math.floor(seconds / 60);
      const rest = Math.floor(seconds % 60);
      const hundredths = Math.floor((seconds % 1) * 100);
      const pad = (value) => String(value).padStart(2, '0');
      return `${pad(minutes)}:${pad(rest)}:${pad(hundredths)}`;
    }

    onMetadata() {
      this.duration.textContent = this.format(this.video.duration);
    }

    onTimeUpdate() {
      const current = this.format(this.video.currentTime);
      this.time.textContent = current;
      const ratio = this.video.duration ? this.video.currentTime / this.video.duration : 0;
      this.progress.style.transform = `translateX(${(ratio - 1) * 100}%)`;
      this.timeline.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      this.timeline.setAttribute('aria-valuetext', current);
    }

    /* Keyboard seeking on the slider: arrows move 5s, Home/End jump to the
       start and the end, like a native range. */
    onTimelineKey(event) {
      if (!this.video.duration) return;
      const step = 5;
      let target = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowUp':
          target = this.video.currentTime + step;
          break;
        case 'ArrowLeft':
        case 'ArrowDown':
          target = this.video.currentTime - step;
          break;
        case 'Home':
          target = 0;
          break;
        case 'End':
          target = this.video.duration;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.video.currentTime = Math.min(Math.max(target, 0), this.video.duration);
      this.onTimeUpdate();
    }

    onPlayState() {
      const playing = !this.video.paused;
      this.iconPlay.hidden = playing;
      this.iconPause.hidden = !playing;
      this.playLabel.textContent = playing
        ? this.playButton.dataset.labelPause
        : this.playButton.dataset.labelPlay;

      if (playing) {
        this.startTicking();
      } else {
        this.stopTicking();
      }
    }

    startTicking() {
      if (this.frame) return;
      const tick = () => {
        this.onTimeUpdate();
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    stopTicking() {
      if (!this.frame) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.onTimeUpdate();
    }

    disconnectedCallback() {
      this.stopTicking();
      document.removeEventListener('fullscreenchange', this.syncFullscreenLabel);
    }

    togglePlay() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    syncMuteLabel() {
      this.muteButton.textContent = this.video.muted
        ? this.muteButton.dataset.labelUnmute
        : this.muteButton.dataset.labelMute;
    }

    toggleMute() {
      this.video.muted = !this.video.muted;
      this.syncMuteLabel();
    }

    syncFullscreenLabel = () => {
      this.fullscreenButton.textContent = document.fullscreenElement === this
        ? this.fullscreenButton.dataset.labelExit
        : this.fullscreenButton.dataset.labelEnter;
    };

    toggleFullscreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        this.requestFullscreen();
      }
    }

    seek(event) {
      if (!this.video.duration) return;
      const bounds = this.timeline.getBoundingClientRect();
      const ratio = (event.clientX - bounds.left) / bounds.width;
      this.video.currentTime = Math.min(Math.max(ratio, 0), 1) * this.video.duration;
    }
  }

  if (!customElements.get('video-player')) {
    customElements.define('video-player', VideoPlayer);
  }
  } catch(e) { console.error(e); }
})();

})();
